import { useQuery } from '@tanstack/react-query'

import { fetchSupportHubSpotContact } from './supportApi'

export const SUPPORT_HUBSPOT_CONTACT_QUERY_KEY = ['supportHubSpotContact'] as const

export const useGetSupportHubSpotContactQuery = () =>
    useQuery({
        queryKey: SUPPORT_HUBSPOT_CONTACT_QUERY_KEY,
        queryFn: fetchSupportHubSpotContact,
        retry: false,
    })
